import Api, { ENABLE_DEVICE_CONFIG_CACHING, INROOMTAB, WITH_MASTER_CONNECTOR, errorCodeOtpValidationForLogin, globalIV, globalSalt } from '../config/constant'
import clientConfigApi from '../config/config'
import axios from 'axios';
import { token } from '../config/constant';
import enText from '../app-text-files/enText.json';
import { CMSPath, defultIP } from '../config/constant'
import { wipeGuestData } from '../JS/wipeGuestData';
import serviceFailureMsg from '../config/constant'
import { getCurrentGuestDetails } from '../layout2.0/JS/utility';
import { dmqEventListener } from '../JS/dmqEventsListener';
import { setGoHome } from "../layout2.0/action/homeAction"
import Axios from 'axios';
import { loadCSS } from '../JS/cssImport';
import smooch from 'smooch';
import { AesUtil } from '../JS/AesUtil';
import { connect } from 'react-redux';
// import { perf } from '../index.js';
// import { trace } from "firebase/performance";

//---------------------------------home actions---------------------------------------//

export const wrongLayoutTypeRenderer = (layoutTypeName, timerRef, props, loaderRef) =>{
  console.log('wrong layout renderer called', layoutTypeName, props)
  if(layoutTypeName != 'webapp-type2'){
    clearTimeout(timerRef) // clears the 10 sec timeout set in App2.jsx if device config don't give response
    clearTimeout(loaderRef) // clears the 10 sec timeout set in App2.jsx if device config don't give response
    props.setServiceUnavailable(true)
    props.setPreloadScreen(false)

    window.location.hash = '/noConnection?msg=' + layoutTypeName + ' is not supported. Please contact support team.' // sets the hash route value to the location
    window.location.href(window.location.hash) // routes the control to service unavailable page
  }
}

const putWithTimeout = (url, payload, timeout = 10000) => {
  const source = axios.CancelToken.source();

  const timeoutId = setTimeout(() => {
    source.cancel("Request timed out");
  }, timeout);

  return clientConfigApi.put(url, payload, {
    cancelToken: source.token
  }).finally(() => {
    clearTimeout(timeoutId);
  });
};


function callApi(path, sessionToken, deviceConfigCacheId, timeout = 10000) {
  try {
    let header = {} 
    if (localStorage.getItem("marketSegmentCode")) {
      header = {
        "age": "36",
        "classificationType": localStorage.getItem("marketSegmentCode"),
        "gender": "male",
        "deviceType": "app"
    };
    } else if (deviceConfigCacheId){
      header = {
        "sessionToken": sessionToken,
        "deviceType": "app",
        "cacheId": deviceConfigCacheId
      }
    } else{
      header = {
        "sessionToken": sessionToken,//token,
        "deviceType": "app"
      }
    }
    const payload = {
      payload: {},
      header: header
    };

    let data = putWithTimeout(path, payload, timeout);
        // .catch(
        //   ({ response = {} }) => {
        //     console.log("Api failed with the status code:", response.status);
        //   }
        // )
    console.log("data",data)
    return data
  } catch (e) {
    console.log(`error in api call to path=${path}`, e);
  }
}

const loadClientConfigLayoutFromCache = (timerRef, props, loaderRef, dispatch, responseData) => {
  // console.log(response.response.status, "response.response.status")

  // const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));
  // const responseData = cachedDeviceConfig;

  responseData.data.webAppWidgetsInfo.durations.map(obj => {
    if (responseData.data.webAppWidgetsInfo.schedules && Object.keys(responseData.data.webAppWidgetsInfo.schedules).length > 0) {
      if (obj.durationId == responseData.data.webAppWidgetsInfo.schedules.en[0].layoutId) {
        wrongLayoutTypeRenderer(obj.layoutTypeName, timerRef, props, loaderRef)
      }
    } else if (obj.durationId == responseData.data.webAppWidgetsInfo.defaultLayout.en[0].layoutId) {
      wrongLayoutTypeRenderer(obj.layoutTypeName, timerRef, props, loaderRef)
    }
  })
  if (window.FirebasePlugin) {
    window.FirebasePlugin.logEvent("device_config_response", { status: "success" });
  }
  dispatch({
    type: "Set_Mobile_Deep_Link",
    payload: responseData.data.webAppInfo ? responseData.data.webAppInfo.deepLink || "" : process.env.REACT_APP_DEEP_LINK || "",
  })
  dispatch({
    type: "Screen_Info_After_Loader",
    payload: responseData.data.webAppWidgetsInfo.screenInfoAfterLoader || {}
  })
  dispatch({
    type: 'Client_Side_Config_Data',
    payload: responseData.data
  })

  dispatch({
    type: 'Set_Language_list_Data',
    payload: responseData.data.languageListForWebApp
  })

  let languageList = []
  responseData.data.languageListForWebApp.map(langObj => {
    languageList.push(langObj.language)
  })
  dispatch({
    type: 'Set_Language_list',
    payload: languageList
  })

  let languageCodeList = []
  responseData.data.languageListForWebApp.map(langObj => {
    languageCodeList.push(langObj.languageCode)
  })
  dispatch({
    type: 'Set_Language_Codes',
    payload: languageCodeList
  })

  dispatch({
    type: 'TV_CHANNEL_MIN_VIEW_DURATION',
    payload: responseData.data.extraConfigParam && responseData.data.extraConfigParam.TV_CHANNEL_MIN_VIEW_DURATION
  })

  if (responseData.data.webAppWidgetsInfo.appConfigs.roomControlInterface) {
    let roomControl = responseData.data.webAppWidgetsInfo.appConfigs.roomControlInterface;

    switch (roomControl) {
      case "INNCOM":
        roomControl = "InnCom";
        break;
      case "LUTRON":
        roomControl = "Lutron"
        break;
      default:
        break;
    }

    localStorage.setItem("roomControlInterface", roomControl)
  }
}

// Action for getting client config from CMS
export const getClientConfig = (sessionToken, props, callBack, timerRef, loaderRef, retryCount=2) => {
  let responseData = {}
  let layoutKey = localStorage.getItem("LayoutMaster");
  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"

    
  const isDeviceConfigDataPresent = (props.clientConfig =="true");
  console.log("isDeviceConfigDataPresent",props.clientConfig, isDeviceConfigDataPresent);
  
  if(!isDeviceConfigDataPresent && window && window.FirebasePlugin) {
      window.FirebasePlugin.startTrace("fetch_device_config_error_code");
      window.FirebasePlugin.startTrace("fetch_device_config_error_message");
    
  }

  let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
  let deviceConfigCacheId;

  if(ENABLE_DEVICE_CONFIG_CACHING && localStorage.getItem(`deviceConfigCache_${current_hotel_code}`) && localStorage.getItem(`deviceConfigCache_${current_hotel_code}`)!="null" ){

    const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));
    deviceConfigCacheId = cachedDeviceConfig.data.cacheId ;

  }

  try {
    return async dispatch => {
      //let sessionData = sessionStorage.getItem("clientConfig");
      //if (!sessionData) {
    
      try{
       
        responseData = await callApi("/deviceConfig" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`, sessionToken, deviceConfigCacheId, 10000);
        console.log("client config response data", responseData);
        if (responseData) {
          //sessionData = JSON.stringify(responseData);
          //sessionStorage.setItem("clientConfig", sessionData);
          // responseData.
  
          if(ENABLE_DEVICE_CONFIG_CACHING) localStorage.setItem(`deviceConfigCache_${current_hotel_code}`, JSON.stringify(responseData));
          
           loadClientConfigLayoutFromCache(timerRef, props, loaderRef, dispatch, responseData)

        if (sessionToken)
          callBack(true)
      } else {
        if (sessionToken)
          callBack(false)
        //sessionData = JSON.parse(sessionData);
        //dispatch({
        //   type: 'Client_Side_Config_Data',
        //   payload: sessionData.data
        // })
        /*dispatch(
          {
            type: 'In_Hotel_Popup',
            payload: {
              status: true,
              errorMsg: "Network Issue."
          if (sessionToken)
            callBack(true)
        } else {
          if (sessionToken)
            callBack(false)
          //sessionData = JSON.parse(sessionData);
          //dispatch({
          //   type: 'Client_Side_Config_Data',
          //   payload: sessionData.data
          // })
          /*dispatch(
            {
              type: 'In_Hotel_Popup',
              payload: {
                status: true,
                errorMsg: "Network Issue."
              }
            }
          )*/
        }
      } catch(e){

        if (axios.isCancel(e)) {
          console.log("Request cancelled due to timeout:", e.message);
        }

        let response= e;
        const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));

        if(!isDeviceConfigDataPresent && window && window.FirebasePlugin ) {
          console.log("ending deviceConfig fpm event", response, response.code, response.message)
          if(response.code) window.FirebasePlugin.incrementCounter("fetch_device_config_error_code",typeof response.code =="string" ? response.code: JSON.stringify(response.code),()=>{console.log("success fetch_device_config_error_code")}, ()=>{console.log("failure fetch_device_config_error_code")});
          if(response.message) window.FirebasePlugin.incrementCounter("fetch_device_config_error_message" , response.message ,()=>{console.log("success fetch_device_config_error_message")}, ()=>{console.log("failure fetch_device_config_error_message")});

          window.FirebasePlugin.stopTrace("fetch_device_config_error_code");
          window.FirebasePlugin.stopTrace("fetch_device_config_error_message");

          if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_code', typeof response.code =="string" ? response.code: JSON.stringify(response.code));
          if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_message', response.message);
          if(window.FirebasePlugin) { window.FirebasePlugin.logError(
                      "A non-fatal error",
                      function () {
                          console.log("Sent non-fatal error");
                      },
                      function (error) {
                          console.error("Failed to send non-fatal error", error);
                      }
                  ); }
        }


        if(response && response.response && response.response.status == 304 && ENABLE_DEVICE_CONFIG_CACHING) {
          loadClientConfigLayoutFromCache(timerRef, props, loaderRef, dispatch, cachedDeviceConfig)
          
          if (sessionToken)
            callBack(true)
          return;
        }

         if(window.FirebasePlugin){
          // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using getClientConfig() session token = " + sessionToken);
          window.FirebasePlugin.logEvent("device_config_response", {status: "failed", error: e.message});
          window.FirebasePlugin.logError("Error in calling the deviceConfig using getClientConfig(): " + e.message)
        }

        if (retryCount > 0) {
          // Retry with decremented count - dispatch the thunk again
          dispatch(getClientConfig(sessionToken, props, callBack, timerRef, loaderRef, retryCount - 1));
        } else {
          // No more retries left, call callback with false
          console.log("All retry attempts exhausted. Calling callback with false.");
          // callBack(false);
          if (cachedDeviceConfig) {            
            loadClientConfigLayoutFromCache(timerRef, props, loaderRef, dispatch, cachedDeviceConfig)
            if (sessionToken){
              if(!navigator.onLine){
                callBack(true, true);
                }else{
                  callBack(true)
                }
            }
            return;
          }

          callBack(false);
        }
       }
      }
    
  } catch (e) { 
    console.log(e) 

    let response = e;
    
      if(!isDeviceConfigDataPresent && window && window.FirebasePlugin ) {
        console.log("ending deviceConfig fpm event..", response, response.code, response.message)
        if(response.code) window.FirebasePlugin.incrementCounter("fetch_device_config_error_code", typeof response.code =="string" ? response.code: JSON.stringify(response.code)  ,()=>{console.log("success fetch_device_config_error_code")}, ()=>{console.log("failure fetch_device_config_error_code")});
        if(response.message) window.FirebasePlugin.incrementCounter("fetch_device_config_error_message", response.message,()=>{console.log("success fetch_device_config_error_message")}, ()=>{console.log("failure fetch_device_config_error_message")});
        
        window.FirebasePlugin.stopTrace("fetch_device_config_error_code");
        window.FirebasePlugin.stopTrace("fetch_device_config_error_message");

        if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_code', typeof response.code =="string" ? response.code: JSON.stringify(response.code));
        if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_message', response.message);
        
        if(window.FirebasePlugin) { window.FirebasePlugin.logError(
          "A non-fatal error",
          function () {
              console.log("Sent non-fatal error");
          },
          function (error) {
              console.error("Failed to send non-fatal error", error);
          }
      ); }

      }

    if(window.FirebasePlugin){
      // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using getClientConfig() session token = " + sessionToken);
      window.FirebasePlugin.logEvent("device_config_response", {status: "failed", error: e.message});
      window.FirebasePlugin.logError("Error in calling the deviceConfig using getClientConfig(): " + e.message)
    }}
}

export const updateCurrentLayout = (currentDuration, durationLang, stringConst) => {
  //console.log("updateCurrentLayout")
  return {
    type: 'Update_Current_Duration',
    payload: {
      currentDuration,
      durationLang,
      stringConst
    }
  }
}

export const updateDefaultLanguage = () => {
  return {
    type: 'Set_default_Lang',
    payload: enText
  }
}

export const setMobileTVPage = bool => {
  return {
    type: 'Set_Mobile_TV_Page',
    payload: bool
  }
}

export const setLanguageList = list => {
  return {
    type: 'Set_Language_list',
    payload: list
  }
}

export const setInstalledAppVersion = num => {
  return {
    type: 'Set_Installed_App_Version',
    payload: num
  }
}

export const setInstalledAppBuildNo = num => {
  return {
    type: 'Set_Installed_App_Build_No',
    payload: num
  }
}

export const setAppName = name => {
  return {
    type: 'Set_App_Name',
    payload: name
  }
}

export const setInstalledAndroidSDKVersion = version => {
  return {
    type: 'Set_Installed_Android_SDK_Version',
    payload: version
  }
}

export const setAppPackageName = name => {
  return {
    type: 'Set_App_Package_Name',
    payload: name
  }
}

export const getWetherInfo = (sessionToken) => {
 if (process.env.REACT_APP_DISABLE_WEATHER_INFO_API == "true") {
    return () => {};
  }

  //console.log("getWetherInfo", sessionToken);
  let data = {}
  return async dispatch => {
    data = await clientConfigApi.put(
      "/apps/weather-fetch",
      {
        "payload": {},
        "header": {
          "sessionToken": sessionToken//token,
        },
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the status code:", response)
        }
      )
    //console.log("weather data", data);
    if (data) {
      dispatch({
        type: 'Weather_Data',
        payload: data
      })
    }
  }
}

//---------------------------------room assitance actions---------------------------------------//

export const roomAssistanceStatusChange = (popupStatus) => {
  return {
    type: 'Room_Assistance_Status',
    payload: popupStatus
  }
}

export const requesForButler = (token, callBackFunction) => {
  return async dispatch => {
    clientConfigApi.post(
      "/qualityPlus/request",
      {
        "header": {
          "sessionToken": "71179797-547b-4a97-a9c7-5e8103019195",
          "guestToken": "-397045254",
          "locationId": 2,
          "loggedinGuestToken": "-397045254"
        },
        "payload": {
          "reservationNumber": "684519",
          "qualityPlusRequest": [
            {
              "serviceRequestId": 25,
              "quantity": "1",
              "additionalNote": "none"
            }
          ],
          "sourceApp": "guestJourneyApp",
          "platform": window.device ? window.device.platform : "Web",
        }
      }
    ).then(
      (response) => {
        console.log("butler response", response);
        callBackFunction(true);
      }
    ).catch(
      (err) => {
        console.log("Api for butler request faild:", err);
        callBackFunction(false);
      }
    )
  }
}

export const requestSkuGroup = (token) => {
  return async dispatch => {
    clientConfigApi.put(
      "qualityPlusGroup/fetch",
      {
        "header": { "sessionToken": "71179797-547b-4a97-a9c7-5e8103019195" },
        "payload": { "qualityPlusReqGroupSku": "10" }
      }
    ).then(
      (response) => {
        console.log("SkuGroup response", response);
      }
    ).catch(
      (err) => {
        console.log("Api for requested SkuGroup faild:", err);
      }
    )
  }
}

export const setLoadingMass = (status) => {
  return {
    type: 'Set_Loading_Mass',
    payload: status
  }
}
//---------------------------------facebook actions---------------------------------------//

export const setFacebookPopup = (status) => {
  return {
    type: 'Set_Facebook_Popup',
    payload: status
  }
}


export const facebookProfile = (img) => {
  return {
    type: 'Set_Facebook_Profile',
    payload: img
  }
}

export const logoutFb = (status) => {
  console.log("action called");
  return {
    type: 'setLogout',
    payload: status
  }
}

export const fbLogoutPopup = (status) => {
  return {
    type: 'FB_Logout_Popup',
    payload: status
  }
}
//-----------------------------------side navigation action------------------------------------//

export const setNavItem = (navItem) => {
  return {
    type: 'Set_Nav_Item',
    payload: navItem
  }
}

export const clickOnLogo = (status) => {
  return {
    type: 'Click_On_Logo',
    payload: status
  }
}

export const updateGuestLang = (lang) => {
  return {
    type: 'Update_Guest_Lang',
    payload: {
      lang
    }
  }
}

export const setAdminPage = (status) => {
  return {
    type: 'Set_Admin_Page',
    payload: status
  }
}

export const currentWidget = (widget) => {
  //console.log("widget", widget)
  return {
    type: 'Set_Current_Widget',
    payload: widget
  }
}
//-----------------------------------------------------------------------//
export const setVideoPlayer = (status, path) => {
  return {
    type: 'Set_Video_PLayer',
    payload: {
      status,
      path
    }
  }
}

export const setFaceData = (faceData) => {
  return {
    type: 'Set_Face_Data',
    payload: faceData
  }
}


const loadFaceBasedLayoutFromCache = (timerRef, props, loaderRef, sessionData, dispatch, localData) => {

  // const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));
  // const localData = cachedDeviceConfig;

  localData.data.webAppWidgetsInfo.durations.map(obj => {
    if (localData.data.webAppWidgetsInfo.schedules && Object.keys(localData.data.webAppWidgetsInfo.schedules).length > 0) {
      if (obj.durationId == localData.data.webAppWidgetsInfo.schedules.en[0].layoutId) {
        wrongLayoutTypeRenderer(obj.layoutTypeName, timerRef, props, loaderRef)
      }
    } else if (obj.durationId == localData.data.webAppWidgetsInfo.defaultLayout.en[0].layoutId) {
      wrongLayoutTypeRenderer(obj.layoutTypeName, timerRef, props, loaderRef)
    }
  })

  console.log("deviceConfig Response: ", localData);
  sessionData = JSON.stringify(localData);
  dispatch({
    type: "Set_Mobile_Deep_Link",
    payload: localData.data.webAppInfo ? localData.data.webAppInfo.deepLink || "" : process.env.REACT_APP_DEEP_LINK || "",
  })
  //uncomment below line after 8 april demo
  sessionStorage.setItem("clientConfig", sessionData);

  localStorage.setItem('hasReservationNumberCheck', localData.data.hasReservationNumberCheck)
  if (window.FirebasePlugin) {
    window.FirebasePlugin.logEvent("device_config_response", { status: "success" });
  }

  dispatch({
    type: "Screen_Info_After_Loader",
    payload: localData.data.webAppWidgetsInfo.screenInfoAfterLoader || {}

  })

  dispatch({
    type: 'Client_Side_Config_Data',
    payload: localData.data
  })

  dispatch({
    type: 'Set_Language_list_Data',
    payload: localData.data.languageListForWebApp
  })
  let languageList = []
  localData.data.languageListForWebApp.map(langObj => {
    languageList.push(langObj.language)
  })
  dispatch({
    type: 'Set_Language_list',
    payload: languageList
  })

  dispatch({
    type: 'TV_CHANNEL_MIN_VIEW_DURATION',
    payload: localData.data.extraConfigParam && localData.data.extraConfigParam.TV_CHANNEL_MIN_VIEW_DURATION
  })

  let languageCodeList = []
  localData.data.languageListForWebApp.map(langObj => {
    languageCodeList.push(langObj.languageCode)
  })
  dispatch({
    type: 'Set_Language_Codes',
    payload: languageCodeList
  })

  dispatch({
    type: "Set_deviceConfifApiCall",
    payload: true
  })

}

export const fetchFaceBasedJson = (faceData, props, callBack, timerRef, loaderRef, retryCount=3) => {

  let faceJson = JSON.parse(faceData);
  let layoutKey = localStorage.getItem("LayoutMaster");
  let room = localStorage.getItem("room")
  room = room & room !== "null" ? room : "notLogin"
  console.log("fetch data called faceJson", faceJson);

  const isDeviceConfigDataPresent = (props.clientConfig =="true");
  console.log("isDeviceConfigDataPresent",props.clientConfig, isDeviceConfigDataPresent);
  
  if(!isDeviceConfigDataPresent && window && window.FirebasePlugin) {
      window.FirebasePlugin.startTrace("fetch_device_config_error_code");
      window.FirebasePlugin.startTrace("fetch_device_config_error_message");
    
  }


  return async dispatch => {
    try {
      let sessionData = sessionStorage.getItem("clientConfig");
      let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
      let deviceConfigCacheId;

      if(ENABLE_DEVICE_CONFIG_CACHING && localStorage.getItem(`deviceConfigCache_${current_hotel_code}`) && localStorage.getItem(`deviceConfigCache_${current_hotel_code}`)!="null" ){

        const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));
        if(cachedDeviceConfig && cachedDeviceConfig.data) deviceConfigCacheId = cachedDeviceConfig.data.cacheId ;
  
      }

      const url = "/deviceConfig" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`;
      const payload = {
        header: {
          "age": `${faceJson.age ? faceJson.age : 42}`,
          "classificationType": `${faceJson.classificationType ? faceJson.classificationType : "Leisure"}`,
          "gender": `${faceJson.gender ? faceJson.gender : "male"}`,
          "deviceType": "app",
          "cacheId": deviceConfigCacheId
        }
      };
      await putWithTimeout(url, payload, 10000).then(
        (localData) => {

          if(ENABLE_DEVICE_CONFIG_CACHING && localData.data.cacheId ) localStorage.setItem(`deviceConfigCache_${current_hotel_code}`, JSON.stringify(localData));
          
          loadFaceBasedLayoutFromCache(timerRef,props,loaderRef,sessionData,dispatch, localData)

          callBack(true);
        }
      )
        .catch(
          (response) => {

            if (axios.isCancel(response)) {
              console.log("Request cancelled due to timeout:", response.message);
            }

            if(!isDeviceConfigDataPresent && window && window.FirebasePlugin ) {
              console.log("ending deviceConfig fpm event", response, response.code, response.message)
              if(response.code) window.FirebasePlugin.incrementCounter("fetch_device_config_error_code",typeof response.code =="string" ? response.code: JSON.stringify(response.code),()=>{console.log("success fetch_device_config_error_code")}, ()=>{console.log("failure fetch_device_config_error_code")});
              if(response.message) window.FirebasePlugin.incrementCounter("fetch_device_config_error_message" , response.message ,()=>{console.log("success fetch_device_config_error_message")}, ()=>{console.log("failure fetch_device_config_error_message")});

              window.FirebasePlugin.stopTrace("fetch_device_config_error_code");
              window.FirebasePlugin.stopTrace("fetch_device_config_error_message");

              if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_code', typeof response.code =="string" ? response.code: JSON.stringify(response.code));
              if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_message', response.message);
    
              if(window.FirebasePlugin) { window.FirebasePlugin.logError(
                "A non-fatal error",
                function () {
                    console.log("Sent non-fatal error");
                },
                function (error) {
                    console.error("Failed to send non-fatal error", error);
                }
            ); }

            }
            
            const cachedDeviceConfig = JSON.parse(localStorage.getItem(`deviceConfigCache_${current_hotel_code}`));

            if(response && response.response && response.response.status == 304 && ENABLE_DEVICE_CONFIG_CACHING) {

              loadFaceBasedLayoutFromCache(timerRef,props,loaderRef,sessionData,dispatch,cachedDeviceConfig )

              callBack(true);

              return;
            }            
            console.log("Api failed with the status code:", response.message)
            if(window.FirebasePlugin){
              // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
              window.FirebasePlugin.logError("Device config failed response = " + response.message)
              window.FirebasePlugin.logEvent("device_config_response", {status: "failed", error: response.message});
            }

            if (retryCount > 0) {
              console.log(`Retrying... Attempts left: ${retryCount - 1}`);
              // Retry with decremented count - dispatch the thunk again
              dispatch(fetchFaceBasedJson(faceData, props, callBack, timerRef, loaderRef, retryCount - 1));
            } else {
              // No more retries left, call callback with false
              console.log("All retry attempts exhausted. Calling callback with false.");
              // callBack(false);
              if (cachedDeviceConfig) {
                loadFaceBasedLayoutFromCache(timerRef, props, loaderRef, sessionData, dispatch, cachedDeviceConfig)
                if(!navigator.onLine){
                callBack(true, true);
                }else{
                  callBack(true)
                }
                return;
              }

              callBack(false);
            }
          }
        )
    } catch (e) {
      let response = e;
      if(!isDeviceConfigDataPresent && window && window.FirebasePlugin ) {
        console.log("ending deviceConfig fpm event..", response, response.code, response.message)
        if(response.code) window.FirebasePlugin.incrementCounter("fetch_device_config_error_code", typeof response.code =="string" ? response.code: JSON.stringify(response.code)  ,()=>{console.log("success fetch_device_config_error_code")}, ()=>{console.log("failure fetch_device_config_error_code")});
        if(response.message) window.FirebasePlugin.incrementCounter("fetch_device_config_error_message", response.message,()=>{console.log("success fetch_device_config_error_message")}, ()=>{console.log("failure fetch_device_config_error_message")});
        
        window.FirebasePlugin.stopTrace("fetch_device_config_error_code");
        window.FirebasePlugin.stopTrace("fetch_device_config_error_message");

        if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_code', typeof response.code =="string" ? response.code: JSON.stringify(response.code));
        if(window.FirebasePlugin) window.FirebasePlugin.setCrashlyticsCustomKey('fetch_device_config_error_message', response.message);

        if(window.FirebasePlugin) { window.FirebasePlugin.logError(
          "A non-fatal error",
          function () {
              console.log("Sent non-fatal error");
          },
          function (error) {
              console.error("Failed to send non-fatal error", error);
          }
      ); }
      }

      console.log("error in fetching json using user data", e);
      if(window.FirebasePlugin){
        // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using faceBasedJson() face data = " + faceData);
        window.FirebasePlugin.logError("Error in calling the deviceConfig using faceBasedJson()" + e)
        window.FirebasePlugin.logEvent("device_config_response", {status: "failed", error: e.message});
      }
    }
  }
}

export const DefaultFaceData = () => {
  let faceData = localStorage.getItem("localFaceData");
  return {
    type: 'Set_Face_Data',
    payload: faceData
  }
}

//update browsers list
export const browserListPopup = (browserList, showPopup) => {
  return {
    type: 'Browsers_List',
    payload: {
      browserList,
      showPopup
    }
  }
}

//enable browser popup by setting browserPopup = true in store
export const showBrowserPopup = (status) => {
  return {
    type: 'Show_Browsers_Popup',
    payload: status
  }
}

//update current language which is used while updating layout
export const updateDurationLang = (lang) => {
  return {
    type: 'Update_Duration_Lang',
    payload: lang
  }
}

export const popupOpenClose = (status, errorMsg) => {
  return {
    type: 'In_Hotel_Popup',
    payload: {
      status,
      errorMsg
    }
  }
}
//----------------------------------Device registration------------------------------------------
export const roomSelectorStatus = (status) => {
  return {
    type: 'Room_Selector_Status',
    payload: status
  }
}

export const testIP = (IP, callBack, deviceName) => {

  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"

  return async dispatch => {
    try {
      await axios.post(
        IP.startsWith("http") ?  
      `${IP}/Connector/rest/currentServerTimeDetails/fetch?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`
        : `http://${IP}:8080/Connector/rest/currentServerTimeDetails/fetch?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`
        // `http://scmahcb.innspire.com/Connector/rest/currentServerTimeDetails/fetch?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`
      ).then((res) => {
        console.log("responce from time", res.data);
        if (res && res.data && res.data.payload) {
          console.log("responce from time", res.data.payload);
          callBack(true, IP, deviceName);
        } else {
          callBack(false, null, null);
        }
      })
        .catch(
          (response) => {
            console.log("Api failed with the status code:", response);
            callBack(false, null, null);
          }
        )
    } catch (e) {
      console.log("error in fetch server time", e);
    }
  }
}

export const getRoomList = (IP) => {
  return async dispatch => {
    axios.put(
      IP.startsWith("http") ?  
      `${IP}/Connector/rest/location/fetch-all`
      : `http://${IP}:8080/Connector/rest/location/fetch-all`,
      // `http://scmahcb.innspire.com/Connector/rest/location/fetch-all`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then((res) => {
      if (res && res.data && res.data.payload) {
        console.log("res", res.data.payload);
        dispatch({
          type: 'Room_List',
          payload: res.data.payload
        })
      }
    })
      .catch(
        (response) => {
          console.log("Api failed with the status code:", response);
          //callBack(false, null);
        }
      )
  }
}


export const setConnectorIP = (IP) => {
  return {
    type: 'Set_Connector_IP',
    payload: IP
  }
}
export const setConformationPage = (status) => {
  return {
    type: 'Set_Conformation_Page',
    payload: status
  }
}

export const setDeviceLoginPage = (status) => {
  return {
    type: 'Set_Device_Login_Page',
    payload: status
  }
}

export const setRegPage = (status) => {
  return {
    type: 'Set_Reg_Page',
    payload: status
  }
}

export const setLauncherWidget = (widget) => {
  return {
    type: 'Set_App_launcher_widget',
    payload: widget
  }
}

export const validateGuestdetail = ({ encodedData, deviceID }, guestName, roomNumber, callBackFunc, reservation_no, otpValidation_configs, isAccompanyLogin={}) => {
  let room = '' //localStorage.getItem("room");
  let roomID = '' //localStorage.getItem("roomID");
  let deviceName = ""
  let otpValidationConfigs =  otpValidation_configs ? otpValidation_configs : {} ;
  let reservationNo = reservation_no ? reservation_no : ""
  const FCMToken = localStorage.getItem("FCM_token");
  const deviceType = window.device ? window.device.platform : "Other";
  let hasReservationNumberCheck = localStorage.getItem('hasReservationNumberCheck')

  let master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
  let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();


  console.log("guestName, roomNumber, SessionToken", guestName, roomNumber);

  return async dispatch => {

        let sessionToken = localStorage.getItem("GuestJourneySessionToken");

        let payload
        if(hasReservationNumberCheck == 'true'){
          payload = {'roomNo': roomNumber,'guestName': guestName,'reservationNumber': reservationNo, guestNotVerified: isAccompanyLogin.guestNotVerified, id: isAccompanyLogin.guestId, accessCode: otpValidationConfigs.accessCode}
        } else {
          payload = {'roomNo': roomNumber,'guestName': guestName, guestNotVerified: isAccompanyLogin.guestNotVerified, id: isAccompanyLogin.guestId, accessCode: otpValidationConfigs.accessCode }
        }

        let header = {
          'Content-Type': 'application/json',
          'requestForOtp': otpValidationConfigs.requestForOtp || false,
          "enableOtpFlow": Boolean( otpValidationConfigs.requestForOtp || otpValidationConfigs.accessCode ),
          'sessionToken': sessionToken
        }


        return axios.post(
          `${CMSPath}/Connector/rest/guestDevice/linkToRoom`,
          {
            "header": header,
            'payload': payload
          }
        ).then((res)=>{
          // check to know if it was failed due to otp validation requirement
          if(res.status=200 && res.data && res.data.payload && !res.data.payload.linkStatus && res.data.payload.failureCode =="OTP") {
            throw {response:res};
          }

          return res
      })  
        .then((res) => {

      if(res.data && res.data.header && res.data.header.status.code == "FAILED" && res.data.payload.failureReason == "Multiple Guest"){
        callBackFunc(false, roomNumber, "", res.data && res.data.header.status.msg, res);
      }else{  
        if (res && res.data && res.data.payload) {
          localStorage.setItem('guestToken',res.data.payload.guestToken)
          res.data.payload.accompanyGuestDetails && Object.keys(res.data.payload.accompanyGuestDetails).length > 0 && localStorage.setItem("accompanyGuestId", res.data.payload.accompanyGuestDetails.id);
          res.data.payload.marketSegmentCode && localStorage.setItem('marketSegmentCode',res.data.payload.marketSegmentCode)

          // Login Initiated for Zingle.
          if( window.device && window.Smooch ){
            console.log("Zingle Login Initiated")
            // here external Id is pmsProfileId.
            window.Smooch.getUserProperties((userMetaData) => {
              if(!userMetaData || Object.keys(userMetaData).length == 0){
                if( res.data.payload.externalId && res.data.payload.externalId != "null") window.Smooch.login(res.data.payload.externalId,res.data.payload.jwtToken)
              } else {
                window.Smooch.logout();

                setTimeout(() => {
                  if( res.data.payload.externalId && res.data.payload.externalId != "null") window.Smooch.login(res.data.payload.externalId,res.data.payload.jwtToken)
                }, 10);
              }
            })
          } else{
            if(sessionStorage.getItem("smoochInit")){
                console.log("Zingle Login Initiated")

                const ZingleLoginCred = {
                  externalId: res.data.payload.externalId,
                  jwtToken: res.data.payload.jwtToken
                }

                if( res.data.payload.externalId && res.data.payload.externalId != "null") localStorage.setItem("zingleCred", JSON.stringify(ZingleLoginCred))
            }
        }
        callBackFunc(true, roomNumber, res.data.payload.locationId);
        }}
      })
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the response:", response);  
          
          if(  !(response.data && response.data.payload && response.data.payload.failureCode && errorCodeOtpValidationForLogin.includes(response.data.payload.failureCode)) &&  response.status == 401){ /// check res. data. payload..
            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
        }
          if(window.FirebasePlugin){
            // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using getClientConfig() session token = " + sessionToken);
            window.FirebasePlugin.logError("/guestDevice/register or /guestDevice/linkToRoom Api failed with the status code:" + response.status)
          }
          // Milind: QuickFix: App removes branding of the hotel and top bar changes color to black.
          sessionStorage.setItem('guestCheckout', true);
          //
          callBackFunc(false, roomNumber, "", response.data && response.data.header.status.msg, response);
          localStorage.removeItem("profile_photo");
          localStorage.removeItem("door_key_opened")
        }
      )
  }
}

export const setDeviceName = (deviceName) => {
  return {
    type: 'Set_Device_Name',
    payload: deviceName
  }
}

export const allColors = (MenuColor) => {
  return {
    type: 'Menu_Color',
    payload: MenuColor
  }
}
export const firstOnHome = (status) => {
  return {
    type: 'First_Time_On_Home',
    payload: status
  }
}
export const setTVtype = (TVtype) => {
  return {
    type: 'Set_TV_Type',
    payload: TVtype
  }
}


//------------------------confromPage------------------------

export const setConformPage = (status, message, compName) => {
  return {
    type: 'Set_Conform_Page',
    payload: {
      status,
      message,
      compName
    }
  }
}

//---------------------------guest list----------------
export const getGuestInRoom = (guestDetail, callback) => {

  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"

  return async dispatch => {
    try {
      if (guestDetail.guestToken && guestDetail.locationId) {
        clientConfigApi.post(
          "/checkInGuestList/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
          {
            "payload": {},
            "header": {
              "locationId": guestDetail.locationId,
              "guestToken": guestDetail.guestToken
            },
          }
        ).then((res) => {
          console.log("res checkInGuestList", res);
          if (res && res.data && res.data.payload && res.data.payload.guestDetails) {
            let list = getCurrentGuestDetails(res.data.payload.guestDetails)
            
            // dispatch({
            //   type: 'Check_In_Guest_List',
            //   payload: res.data.payload.guestDetails
            // })

            // updated checkInGuestlist to only have loggedInGuest
            dispatch({
              type: 'Check_In_Guest_List',
              payload: list
            })
            dispatch({
              type: 'Set_Current_Logged_In_Guest_Details',
              payload: list
            })
          }
          if(callback)
            callback()
        })
          .catch(
            ({ response = {} }) => {
              if(response.status == 401){
                wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
            }
              console.log("checkInGuestList Api failed with the status code:", response.status);
            }
          )
      }
    } catch (e) {
      console.log(`error in api call to path= "/checkInGuestList/fetch"`, e);
    }
  }
}

export const setOrderDetailPage = (status, orderDetail) => {
  return {
    type: 'Set_Order_Detail_Page',
    payload: {
      status,
      orderDetail
    }
  }
}

export const setTVConformPage = (status) => {
  return {
    type: 'Set_TV_Conform_Page',
    payload: status
  }
}


// --------------------- Check Booking Status ---------------------

export const checkBookingStatus = () => {

  return async dispatch => {
    if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
      let aesUtil = new AesUtil(128, 1000);
      let preCheckInDataPayload = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")))

      let formData = new FormData();
      formData.append('confirmationNumber', preCheckInDataPayload.confirmationNumber.trim());
      formData.append('lastName', preCheckInDataPayload.lastName.trim());
      formData.append("actionKey", "bookingDataEnquiry");
      formData.append("legNumber", "");
      formData.append("sessionToken", localStorage.getItem("GuestJourneySessionToken"));
      formData.append("checkinDate", preCheckInDataPayload.checkinDate);

      try {
        clientConfigApi.post("/mobileCheckIn/guestBooking", formData)
          .then((res) => {
            if (res.status == 200) {


              dispatch({
                type: "PRE_CHECKIN_BOOKING_STATE",
                payload: true
              })
            }
          })
          .catch((err) => {
          })
      } catch (error) {
      }
    }
  }
}

export const setPreCheckInBookingState = (bool) => {
  return {
    type: "PRE_CHECKIN_BOOKING_STATE",
    payload: bool
  }
} 

//------------------------Health service----------------------------

export const HealthService = (guestDetail) => {

  let aesUtil = new AesUtil(128, 1000);

  return async dispatch => {
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    let room = localStorage.getItem("room")
    let currentLayoutId = localStorage.getItem("currentLayoutId")
    let currentCSSVersion = localStorage.getItem('currentCSSVersion')
    let queueReservationDetails = localStorage.getItem("X_CHECKIN_PQ_DATA") && JSON.parse(aesUtil.decrypt( globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA")))
    room = room && room !== "null" ? room : "notLogin"

    try {
      clientConfigApi.post(
        "/core/webAppPing" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "header": {
            "sessionToken": sessionToken,
          },
          "payload": {
            "ipAddress": defultIP,
            "isInRoomMobileDevice": INROOMTAB,
            "bookingNumber": queueReservationDetails ? queueReservationDetails.confirmationNumber : null,
            "layoutId": currentLayoutId
          }
        }
      ).then((res) => {
        console.log("res webAppPing", res);
        let guestCheckout = sessionStorage.getItem('guestCheckout');
        if (res && res.data && res.data.payload) {
          //console.log("isGuestCheckedIn", res.data.payload.isGuestCheckedIn);
          if(res.data.payload.commands.length > 0){
            // c.priority c.params c.id

            let commands = res.data.payload.commands;
            commands.sort((a,b) => a.priority - b.priority);
            commands.map((c) => {

              console.log("res webAppPing triggered" + c.type)
              if(c.type == "QUEUED_GUEST_CHECKED_IN"){
                localStorage.setItem("room",c.params.roomNumber)
                dispatch({
                  type: "Queued_CheckIn_RoomNumber",
                  payload: c.params.roomNumber
                })
              }

              if(c.type == "DEVICE_REGISTRATION"){
                localStorage.setItem("roomID", c.params.locationId)
              }

              setTimeout(() => {
                dmqEventListener(c.type);
              }, 1000);
              
            })
            console.log("dmq commands received",commands);
        }
          dispatch({
            type: 'Guest_Checked_Out',
            payload: res.data.payload.isGuestCheckedIn
          })
          if(res.data.payload.layoutCssData && res.data.payload.layoutCssData[0].cssVersion && res.data.payload.layoutCssData[0].cssVersion > currentCSSVersion){
            console.log('Css from custom css file rendered')
            loadCSS(`${CMSPath}${res.data.payload.layoutCssData[0].customCSSFile}`, res.data.payload.layoutCssData[0].cssVersion)
            localStorage.setItem('currentCSSVersion', res.data.payload.layoutCssData[0].cssVersion)
          }
        }
        if (`${guestCheckout}` === "false")
          sessionStorage.setItem('guestCheckout', "");
      })
        .catch(
          ({ response = {} }) => {
            let guestCheckout = sessionStorage.getItem('guestCheckout');
            console.log("HealthService Api failed with the status code:", response.status);
            if (response.status === 401) {
              if (!guestCheckout && guestCheckout !== "false")
                sessionStorage.setItem('guestCheckout', true);
                localStorage.setItem('GuestCheckedOut', true)
                wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
            }
          }
        )
    } catch (e) {
      console.log(`error in api call to path= "/checkInGuestList/fetch"`, e);
    }
  }
}

export const validateDigitalKey = (token, guestDetails, reservationNumber, action, callback, cancelSource) => {
  console.log('validate api called')
  return async dispatch => {
    clientConfigApi.post('guest/digitalKey',
      {
        header: {
          "sessionToken": token,
          "action": action
        },
        payload: {
          "locationId": guestDetails.location,
          "guestToken": guestDetails.guestToken,
          "reservationNumber": reservationNumber
        }
      },
      {
          cancelToken: cancelSource.token ? cancelSource.token : ''
      }
    ).then((res) => {
      console.log('validate api got response', res.data.payload, action)

      if(action == "validateStatus"){
        if(res.data.header.status && res.data.header.status.code == "SUCCESS"){
          callback(true)
        } else{
          callback(false, res.data.header.msg)
          wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
        }
      } else {
        console.log('inside else for digi key')
        // if(res.data.payload.issueKeyFlag == 'true'){
          dispatch({
            type: "Set_DigiTal_Key_Verified",
            payload: res.data.payload.issueKeyFlag
          })
    
          callback(res.data.payload.issueKeyFlag, res.data.payload.message)
        console.log('callback sent', res.data.payload.issueKeyFlag, res.data.payload.message)
      // }
      }

    }).catch(({response = {}}) => {
      console.log('validateDigitalKey api failed', response.status)
      if(response.status == 401){
        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
      }
      if(response.status == undefined) {callback(undefined, "Something went wrong. Error - " + response.status); setGoHome(true);  return}
      let error = response.data && response.data.header && response.data.header.status && response.data.header.status.msg ? response.data.header.status.msg : "Something went wrong. Error - " + response.status
        callback(false, error)
  })
  }
}

export const getDigitalKeySupportedAuthMethods = (token, guestDetails, reservationNumber, callBack) => {
  console.log('validate api called')
  return async dispatch => {
    clientConfigApi.post('guest/digitalKey',
      {
        header: {
          "sessionToken": token,
          "action": "requestSupportedMethods"
        },
        payload: {
          "locationId": guestDetails.locationId,
          "guestToken": guestDetails.guestToken,
          "reservationNumber": reservationNumber
        }
      }
    ).then((res) => {
        dispatch({
          type: "Set_DigiTal_Key_Supported_Auth_Methods",
          payload: res.data.payload.supportedMethods
        })
        callBack(true,"",res.data.payload.supportedMethods)
    }).catch(({response = {}}) => {
      if(response.status == 401){
        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
      }
      let error = response.data && response.data.header && response.data.header.status && response.data.header.status.msg ? response.data.header.status.msg : "Something went wrong. Error - " + response.status
      console.log("requestSupportedMethods api failed with error: ", error);
      callBack(false, error)
  })
  }
}

export const setDigitalKeySupportedAuthMethods = obj => {
  console.log("supportedMethods", obj);
  return {
    type: "Set_DigiTal_Key_Supported_Auth_Methods",
    payload: obj
  }
}

export const requestOTP = (token, guestDetails, reservationNumber, callback) => {
  console.log('requesting otp')
  return async dispatch => {
    clientConfigApi.post('guest/digitalKey',
      {
        header: {
          "sessionToken": token,
          "action": "requestOTP"
        },
        payload: {
          "locationId": guestDetails.locationId,
          "guestToken": guestDetails.guestToken,
          "reservationNumber": reservationNumber
        }
      }
    ).then((res) => {
          callback(true, res.data.payload.message)
    }).catch(({response = {}}) => {
      if(response.status == 401){
        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
      }
      let error = response.data && response.data.message ? response.data.message : 
                  response.data && response.data.header && response.data.header.status && response.data.header.status.msg ? response.data.header.status.msg 
                  : "Something went wrong. Error - " + response.status
        callback(false, error)
  })
  }
}

export const validateOTP = (token, guestDetails, reservationNumber, accessCode, callback) => {
  console.log('validate api called')
  return async dispatch => {
    clientConfigApi.post('guest/digitalKey',
      {
        header: {
          "sessionToken": token,
          "action": "validateOTP"
        },
        payload: {
          "locationId": guestDetails.locationId,
          "guestToken": guestDetails.guestToken,
          "reservationNumber": reservationNumber,
          "accessCode": accessCode
        }
      }
    ).then((res) => {
          callback(true, res.message)
    }).catch(({response = {}}) => {
      if(response.status == 401){
        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
      }
      let error = response.data && response.data.message ? response.data.message : 
                  response.data.header && response.data.header.status && response.data.header.status.msg ? response.data.header.status.msg 
                  : "Something went wrong. Error - " + response.status
        callback(false, error)
  })
  }
}

//---------------------end Health service------------------------

export const setPreloadScreen = (status) => {
  //console.log("setPreloadScreen", status)
  return {
    type: 'Set_Preload_Screen',
    payload: status
  }
}

//--------------------- Door Key Page -----------------------------
export const setDoorKeyNotificaionPage = (status) => {
  return {
    type: 'Set_DoorKey_Notificaion_Page',
    payload: status
  }
}

export const setDoorKeyValidationPopUp = (status) => {
  return {
    type: 'Set_Door_Key_Validation_PopUp',
    payload: status
  }
}

export const validateReservationNo = (sessionToken, reservationNo, loccationId, callBackFun) => {
  console.log("called validateReservationNo", sessionToken, reservationNo, loccationId)
  return async dispatch => {
    clientConfigApi.post(
      "/guest/validateGuest",
      {
        "header": {
          "sessionToken": sessionToken,
          "reservationNumber": reservationNo,
          "locationId": loccationId
        },
        "payload": {}
      }
    ).then((res) => {
      console.log("res validateReservationNo", res);
      if (res && res.data && res.data.header && res.data.header.status.code === "SUCCESS") {
        console.log("validateReservationNo success")
        localStorage.setItem("reservationNo", reservationNo);
        callBackFun(true);
      } else {
        callBackFun(false);
      }
    })
      .catch(
        ({ response = {} }) => {
          callBackFun(false);
          console.log("validateReservationNo Api failed with the status code:", response.status);
        }
      )
  }
}

export const SetCallNativeMethods = (status) => {
  return {
    type: 'Set_Call_Native_Methods',
    payload: status
  }
}

export const setQRScannerPage = (status) => {
  return {
    type: 'Set_QR_Scanner_Page',
    payload: status
  }
}

export const setErrorPopDoorKey = (status) => {
  return {
    type: 'Set_Error_Pop_Door_Key',
    payload: status
  }
}

export const setToRescan = (status) => {
  return {
    type: 'Set_To_Rescan',
    payload: status
  }
}

export const setLocationId = (locationId) => {
  return {
    type: 'Set_Location_Id',
    payload: locationId
  }
}

export const setDeviceConfigFailed = bool => {
  return{
      type:"Set_device_config_failed",
      payload : bool
  }
}

export const setServiceUnavailable = bool => {
  return{
      type:"Set_Service_Unavailble",
      payload : bool
  }
}

export const setChatBubble = bool => {
  return{
      type:"Set_Chat_Bubble",
      payload : bool
  }
}

export const setCameraPermission = bool => {
  return{
    type: "set_Camera_Permission",
    payload : bool
  }
}

export const setMobileOverlayState = bool => {
  return{
    type: "Set_Mobile_Overlay_State",
    payload: bool
  }
}

export const setCurrentWindow = window => {
  return{
    type: "Set_Current_Window",
    payload: window
  }
}

export const setHcommerceSku = str => {
  return{
    type: "Set_Hcommerce_Sku",
    payload: str
  }
}

export const setGuesLogin = bool => {
  return{
    type: "Set_User_Login",
    payload: bool
  }
}

export const setGuestCheckin = bool => {
  return{
    type: "Set_User_Checkin",
    payload: bool
  }
}

export const setMultiSubWidget = (obj) => {
  return{
    type: "SET_MULTI_SUB_WIDGET",
    payload: obj
  }
}

export const setDisableOrderPopup = bool => {
  return {
    type: "Set_Disable_Order_Popup",
    payload: bool
  }
}

export const setGuestLogin = bool => {
  return {
    type: "Set_Guest_Login",
    payload: bool
  }
}

export const setShowValidationOption = bool => {
  return {
    type : "Show_Validation_Option",
    payload : bool
  }
}

export const setTakeWebPicture = bool => {
  return {
    type : "Take_Web_Picture",
    payload : bool
  }
}

export const setPreCheckInWidgetState = (state) => {
  return {
    type: "Check_Pre_CheckIn_Widget_State",
    payload: state
  }
}

export const setFailScreen = (showFailScreen, failScreenMessage1, failScreenMessage2, showClose) => {
  return {
    type: "Set_Fail_Screen",
    payload: {
      showFailScreen: showFailScreen,
      failScreenMessage1: failScreenMessage1,
      failScreenMessage2: failScreenMessage2,
      showClose: showClose,
    }
  }
}

export const setCardChecksData = (obj) => {
  return {
    type: "Set_Card_Checks_Data",
    payload: obj
  }
}

export const setCallKeyclick = bool => {
  return {
    type: "Set_Call_Key_Click",
    payload: bool
  }
}

export const setCheckInAddress = (obj) => {
  return {
    type: "SET_CHECKIN_ADDRESS",
    payload : obj
  }
}

export const openSMSWidget = (bool) => {
  return {
    type: "Open_SMS_Widget",
    payload: bool
  }
}

export const setShowBookmarkPopup = (bool) => {
  return {
    type: "Show_Bookmark_Popup",
    payload: bool
  }
}

export const setHotelSelectionAfterLoginState = (state, hotelData = {}) => {
  return {
    type: "HOTEL_SELECTION_AFTER_LOGIN",
    payload: {
      showPopup: state,
      hotelData: hotelData
    }
  }
}

export const setRenderHomePage = (bool) => {
  return {
    type: "RENDER_HOME_PAGE",
    payload: bool
  }
}

export const setOpenProfileImage = (bool) => {
  return {
    type: "Set_Open_Profile_Edit",
    payload: bool
  }
}

export const setFeatureNotAvailOnWeb = (obj) => {
  return {
    type: "Set_Feature_Not_Avail_Web",
    payload: obj
  }
}

export const setQueuedCheckInSuccess = (bool) => {
  return {
    type: "Queued_CheckIn_Success",
    payload: bool
  }
}

export const setShowAutoLoginPopup = (bool, data={}) => {

return {
      type: "SHOW_AUTO_LOGIN_POPUP",
      payload: {
        status: bool,
        data: data
      }
    }
}

export const showAdhocAction = (bool) => {
  return {
    type: "Show_Adhoc",
    payload: bool
  }
}

export const updateAdhocData = (obj) => {
  return {
    type: "Adhoc_Data",
    payload: obj
  }
}

export const setQueuedCheckInRoomNumber = (number) => {
  return {
    type: "Queued_CheckIn_RoomNumber",
    payload: number
  }
}


export const setUnreadMessageCountWeb = (number) => {
  return {
    type: "Unread_Message_Count_Chat",
    payload: number
  }
}

export const setZingleOnStatus = (bool) => {
  return {
    type: "Zingle_on_Initiated",
    payload: bool
  }
}

export const showGuestItinerary = (status, itinerary) => {
  return {
    type: "SHOW_GUEST_ITINERARY_DETAILS",
    payload: {
      status: status,
      itineraryData: itinerary || {}
    }
  }
}

export const setShowTVLiftWidget = (bool) => {
  return {
    type: "Set_Show_TV_Lift",
    payload: bool
  }
}

export const setShowCustomPopup=(shouldShow,configs)=>{
  return {
    type:"SHOW_CUSTOM_POPUP",
    payload: {
      status:shouldShow,
      configs
    }
  }
}

/* playOnTV
export const profileData = () => {
  return async dispatch => {
    let [responseData = {}] = [await axios.get(
      "http://192.168.1.157:8080/Connector/rest/guestDetails/fetch",
      {
        "header": {
          "sessionToken": "75b7dbf7-118e-4691-b685-6cd62af4d03b"
        },
        "payload": {}
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the status code:", response.status)
        }
      )]
    if (responseData.data) {
      console.log("profile info", responseData)
      //if()
      dispatch({
        type: 'Name_Profile_Data',
        payload: responseData.data
      }
      );
    }
  }
}
*/
